import {v4 as uuid} from "uuid";

window.uuid = uuid;
